"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _alert = _interopRequireDefault(require("../../../core/alert"));
var _groupEmail = _interopRequireDefault(require("../../../core/group-email"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
// *******************************************************************************
// Flag Filters
// *******************************************************************************
const flags = [{
  id: 'isLate',
  description: 'Late Applications',
  canClear: true,
  trueLabel: 'Late Application',
  falseLabel: 'Applied on Time',
  enabled: applications => applications.some(app => app.applicationTiers.some(ad => ad.isLate)) && applications.some(app => app.applicationTiers.some(ad => !ad.isLate)),
  check: (state, application) => state.isLate === null || state.isLate && application.applicationTiers.some(ad => ad.isLate) || state.isLate !== null && !state.isLate && application.applicationTiers.some(ad => !ad.isLate)
}, {
  id: 'hasRiskAssessment',
  description: 'Risk Assessments',
  canClear: true,
  trueLabel: 'Received',
  falseLabel: 'Outstanding',
  enabled: applications => applications.some(app => app.hasRiskAssessment) && applications.some(app => !app.hasRiskAssessment),
  check: (state, application) => state.hasRiskAssessment === null || state.hasRiskAssessment === application.hasRiskAssessment
}];
// *******************************************************************************
// Filter Sets
// *******************************************************************************
const filterSets = props => [{
  id: 'includeTiers',
  description: 'Tiers',
  options: (state, filteredApplications) => props.defaultTiers.filter(tier => tier.isInCalendar && (state.includeTiers.includes(tier.id) || filteredApplications.some(app => app.applicationTiers.some(ad => ad.tierRef === tier.id)))),
  check: (state, app) => !state.includeTiers.length || app.applicationTiers.some(ad => state.includeTiers.includes(ad.tierRef))
}, {
  id: 'includeStatus',
  description: 'Application Status',
  options: (state, filteredApplications) => props.applicationStatusRefs.filter(ref => !ref.isExpired && (state.includeStatus.includes(ref.refCode) || filteredApplications.some(app => app.applicationStatusRef === ref.refCode))).map(ref => {
    return {
      id: ref.refCode,
      description: ref.description
    };
  }),
  check: (state, application) => !state.includeStatus.length || state.includeStatus.includes(application.applicationStatusRef)
}];
// *******************************************************************************
// Email Fields
// *******************************************************************************
const emailFields = [{
  id: 'contactEmail',
  description: 'Application Contact',
  default: true,
  emailAddresses: application => [application.contactEmail]
}
// Temporarily exclude the following whilst we work out the new stuff
// {
//   id: 'organiserEmail',
//   description: 'Organiser',
//   default: false,
//   emailAddresses: (application) => [application.organiserEmail],
// },
// {
//   id: 'entriesEmail',
//   description: 'Person Taking Entries',
//   default: false,
//   emailAddresses: (application) => [application.entriesEmail],
// },
// {
//   id: 'publishedEmail',
//   description: 'Email in Yearbook',
//   default: false,
//   emailAddresses: (application) => [application.publishedEmail],
// },
];

// *******************************************************************************
// Main Component
// *******************************************************************************
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "The calendar has not been set up yet");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this page");
var _ref3 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "When sending group emails always use back copy (bcc) to keep the email addresses private."), /*#__PURE__*/_react.default.createElement("p", null, "For large groups consider splitting into multiple emails to avoid spam filters"));
class ContactOrganisers extends _react.Component {
  render() {
    if (!this.props.calendar) return _ref;
    if (!this.props.userIsCalendarOfficer) return _ref2;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref3, /*#__PURE__*/_react.default.createElement(_groupEmail.default, {
      flags: flags,
      filterSets: filterSets(this.props),
      emailFields: emailFields,
      dataRecords: this.props.calendar.applications,
      sender: this.props.userEmail,
      emailSubject: 'Calendar Applications for ' + this.props.match.params.yearID
    }));
  }
}
// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref4 = {
  applications: {
    id: true,
    applicationStatusRef: true,
    contactEmail: true,
    organiserEmail: true,
    hasRiskAssessment: true,
    applicationTiers: {
      id: true,
      tierRef: true,
      isLate: true
    }
  }
};
var _ref5 = {
  "tierRef as id": true,
  "tierDescription as description": true,
  isInCalendar: true
};
var _ref6 = {
  refCode: true,
  description: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ContactOrganisers, props => ({
  userEmail: true,
  userIsCalendarOfficer: true,
  ["calendar(yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref4,
  ["defaultTiersByYear(yearID:" + JSON.stringify(+props.match.params.yearID) + ") as defaultTiers"]: _ref5,
  "refCodes(codeType:\"applicationstatus\") as applicationStatusRefs": _ref6
}));